module.exports = __webpack_public_path__ + "img/applet.d122ec80.svg";